<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      show-save-button
      unit="收款单"
      edit-title
      id-key="DocId"
      :data="data"
      :line-form="true"
      form-label-width="95px"
      :form-rules="rules"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      :save-func="() => {}"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="单据编号" prop="DocNo">
                <span class="detail-span">{{ data.DocNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker type="date" v-model="data.DocDate" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="往来单位" prop="TradeUnitId" :rules="data.NeedTradeUnit ? tu : null">
                <customer @restaurants="setSupplier" :state="data.TradeUnitName" :typeList="[1, 3]" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务类型">
                <el-select v-model="data.BusinessType" placeholder="请选择业务类型">
                  <el-option label="应收款" :value="0"></el-option>
                  <el-option label="预收款" :value="1"></el-option>
                  <el-option label="直接收款" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经办人" prop="EmpId">
                <select-input placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="折让金额" prop="TotalAllowanceAmount">
                <el-input @blur="onInput4()" type="number" v-model="data.TotalAllowanceAmount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="摘要">
                <el-input type="textarea" v-model="data.Summary" placeholder="请输入摘要"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px">
          <span>收款信息</span>
          <div style="float: right">
            <el-button type="primary" icon="el-icon-plus" @click="addDts">添加</el-button>
          </div>
        </div>
        <el-table class="tb-c-head" show-summary :data="data.Dts" border>
          <el-table-column label="结算方式" min-width="120px">
            <template slot-scope="{ row }">
              <el-select v-model="row.SettleId" @change="setSettle(row)" placeholder="请选择结算方式">
                <el-option v-for="(i, key) in Settles" :key="key" :label="i.SettleName" :value="i.SettleId"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="收款账号" min-width="150px">
            <template slot-scope="{ row }">
              <!-- <account-select
                v-model="row.AccountName"
                :source="DAccount"
                @select="onSelect($event, row)"
              /> -->
              <account-select
                v-model="row.AccountName"
                :source="DAccount"
                @select="onSelect($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @currentPage="currentPage($event, row)"
                @click.native="resetFun(row)"
                @inputText="inputText($event, row)"
                :pageType="true"
              />
            </template>
          </el-table-column>
          <el-table-column label="收款金额" prop="ReceiptAmount" width="110px">
            <template slot-scope="{ row }">
              <el-input type="number" v-model="row.ReceiptAmount" @blur="onInput4(row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="200px">
            <template slot-scope="{ row }">
              <el-input type="textarea" autosize @input="onInput1(row)" v-model="row.Remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="delDts(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="data.BusinessType == 0">
          <div class="row-tb-head" style="margin-top: 10px">
            <span>核销单据明细</span>
            <div style="float: right" v-if="!isEdit || WoDocs.length == 0">
              <el-form-item label="单据日期">
                <range-picker
                  @change="
                    x => {
                      SearchData.DocDateStart = x.Start
                      SearchData.DocDateEnd = x.End
                    }
                  "
                />
                <el-button type="primary" @click="search" style="margin-left: 20px">查询</el-button>
              </el-form-item>
              <!-- <el-button type="primary" plain @click="clear">清空</el-button> -->
            </div>
          </div>
          <div class="row-tb-head">
            <span>
              <span>待核销单据：</span>
              <span class="head-item" style="width: 60px">{{ Detail.ToCount }}</span>
            </span>
            <span>
              <span>已核销单据：</span>
              <span class="head-item" style="width: 60px">{{ Detail.IsCount }}</span>
            </span>
            <span>
              <span>未核销金额：</span>
              <span class="head-item">{{ parseFloat(Detail.ToAmount).toFixed(2) }}</span>
            </span>
            <span>
              <span>本次核销金额：</span>
              <span class="head-item">{{ parseFloat(Detail.ThisAmount).toFixed(2) }}</span>
            </span>
            <span>
              <span>核销差额：</span>
              <span class="head-item">{{ (parseFloat(Detail.ToAmount) - parseFloat(Detail.ThisAmount)).toFixed(2) }}</span>
            </span>
            <div style="float: right" v-if="isEdit">
              <el-button type="primary" plain @click="clear">清空已核销明细</el-button>
            </div>
          </div>
          <el-table class="tb-c-head" :data="WoDocs" border @selection-change="onTbSelect">
            <el-table-column type="selection" align="center" fixed width="50" />
            <el-table-column label="单据类型" prop="SrcVouTypeName" min-width="110px" />
            <el-table-column label="单据编号" prop="SourceNo" min-width="180px" show-overflow-tooltip />
            <el-table-column label="单据日期" prop="DocDate" min-width="100px">
              <template slot-scope="{ row }">{{ $commonJs.toDateString(row.DocDate) }}</template>
            </el-table-column>
            <el-table-column label="总核销金额" prop="Amount" min-width="90px" />
            <el-table-column label="待核销金额" prop="ReceiptAmount" min-width="90px" />
            <el-table-column label="已核销金额" prop="AlreadyWriteoffAmount" min-width="90px" />
            <el-table-column label="本次核销金额" prop="WriteoffAmount" width="110px">
              <template slot-scope="{ row }">
                <el-input @blur="onInput2(row, 'WriteoffAmount')" type="number" v-model="row.WriteoffAmount"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="折让金额" prop="AllowanceAmount" width="110px">
              <template slot-scope="{ row }">
                <el-input @blur="onInput3(row, 'AllowanceAmount')" type="number" v-model="row.AllowanceAmount" :disabled="row.Adisable"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="200px">
              <template slot-scope="{ row }">
                <el-input type="textarea" autosize @input="onInput2(row)" v-model="row.Remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import customer from '@/components/common/customer/customer'
import empDialog from '@/components/ent/emp/listDialog'
import accountSelect from '@/components/basedoc/account/select'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    customer,
    empDialog,
    accountSelect
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocType: 0, //付款单/付款退款单
        DocNo: '', //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: '',
        TradeUnitType: 0, //往来单位性质 - 客户/供应商/客户&供应商/外协
        SourceId: null, //来源单据Id
        SourceNo: '', //来源单据编号
        SourceType: 0, //来源类型 - 进货单
        BusinessType: 0, //业务类型 - 应收款/预收款
        EmpId: null, //经办人
        EmpName: '',
        Summary: '', //摘要
        ReceiptAmount: null, //付款金额
        Remark: '', //备注
        Status: 0, //草稿/未生效/已生效
        Dts: [],
        WoDocs: [], //付款单核销单据
        WoDts: null,
        TotalAllowanceAmount: null //折让金额
      },
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      listTotal: 0,
      allIds: [],
      allTotal: 0,
      curRows: [],
      WoDocs: [],
      DelWoDocs: [],
      DelDts: [],
      Settles: [], //结算方式列表
      DAccount: [],
      Rows: [], //选择的核销单据明细
      Detail: {
        ToCount: 0, //待核销单据
        IsCount: 0, //已核销单据
        ToAmount: 0, //未核销金额
        ThisAmount: 0, //本次核销金额
        DiffAmount: 0 //核销差额
      },
      initDAccount: [],
      DtsTotal: 0,
      api: require('@/api/rp/receipt').default,
      settle_api: require('@/api/ba/settle').default,
      billApi: require('@/api/sy/bill').default,
      account_api: require('@/api/ba/account').default,
      wodoc_api: require('@/api/rp/woDoc').default,
      rules: {
        DocNo: [{ required: true, message: '单据编号不能为空' }],
        DocDate: [{ required: true, message: '单据日期不能为空' }],
        TradeUnitId: [{ required: true, message: '请选择往来单位' }],
        EmpId: [{ required: true, message: '请选择经办人' }]
      },
      SearchData: {
        DocDateStart: '',
        DocDateEnd: ''
      },
      AccountName: ''
    }
  },
  mounted() {
    // this.account_api.list({ Status: 1 }).then((res) => {
    //   if (res.Code == 0) this.DAccount = res.Data;
    // });
    this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7 }).then(res => {
      if (res.Code == 0) (this.DAccount = res.Data), (this.initDAccount = res.Data), (this.initTotal = res.Count)
    })

    this.settle_api.list({ Status: 1 }).then(res => {
      if (res.Code == 0) this.Settles = res.Data
    })
  },
  methods: {
    resetFun(row) {
      //if(!row.AccountName){
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
      //}
    },
    currentPage(val, row) {
      let AccountName = row.AccountName
      this.pageParams.pageIndex = val
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 7, AccountName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      if (text == row.AccountName) {
        //console.log("相同", text);
        return
      }
      row.AccountName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7, AccountName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    onInputAmount() {
      if (!this.data.TotalAllowanceAmount || this.data.TotalAllowanceAmount < 0) {
        this.data.TotalAllowanceAmount = 0
      }
      var amount = this.data.TotalAllowanceAmount
      this.WoDocs.forEach(item => {
        if (this.curRows.includes(item.SourceId)) {
          item.T = item.T === 0 ? 0 : 1
          if (amount <= 0) {
            this.$set(item, 'AllowanceAmount', 0)
          } else if (this.pickId(item.SourceId)) {
            if (amount > 0) {
              this.$set(item, 'AllowanceAmount', amount)
            } else {
              this.$set(item, 'AllowanceAmount', 0)
            }
          } else {
            if (item.ReceiptAmount >= 0 && item.ReceiptAmount >= item.WriteoffAmount) {
              var num = item.ReceiptAmount - item.WriteoffAmount
              if (amount < num) {
                num = amount
              }
              this.$set(item, 'AllowanceAmount', num)
              amount = amount - num
            } else {
              this.$set(item, 'AllowanceAmount', 0)
            }
          }
        }
      })
      this.setWriteoffAmount()
    },
    pickId(id) {
      for (let i = this.WoDocs.length - 1; i > -1; i--) {
        if (this.curRows.includes(this.WoDocs[i].SourceId)) {
          return id == this.WoDocs[i].SourceId
        }
      }
    },
    onInput3(row, type) {
      row.T = row.T == 0 ? 0 : 1
      if (!row[type] || row[type] < 0) {
        this.$set(row, 'AllowanceAmount', 0)
      }
      let num = 0
      this.WoDocs.map(item => {
        if (this.curRows.includes(item.SourceId)) {
          num += Number(item.AllowanceAmount)
        }
      })
      this.data.TotalAllowanceAmount = num
    },
    onCreateOpened(data) {
      var user = this.$store.state.user
      // console.log("user", JSON.parse(JSON.stringify(user)));
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
      }
      this.billApi.getDefaultSerialNo('收款单').then(res => {
        if (res.Code == 0) {
          this.data.DocNo = res.Data
        } else {
          this.$message.warning('获取收款单编号失败')
        }
      })
    },
    onEditOpened(data) {
      this.isEdit = true
      this.data.Dts.forEach(x => (x.T = null))
      this.DtsTotal = this.data.Dts.map(x => x.ReceiptAmount).reduce((a, b) => a + b)
      this.data.TotalAllowanceAmount = data.DiscountAmount
      data.WoDocs.forEach(x => {
        x.T = null
        this.WoDocs.push({
          WoDocId: x.WoDocId,
          DocId: x.DocId,
          DocDate: x.DocDate,
          SourceId: x.SourceId,
          SourceNo: x.SourceNo,
          SourceType: x.SourceType,
          SrcVouType: x.SrcVouType,
          SrcVouTypeName: x.SrcVouTypeName,
          Amount: Math.round(x.Amount * 10000) / 10000,
          ReceiptAmount: Math.round((x.Amount - Number(x.WriteoffAmount || 0)) * 10000) / 10000,
          AlreadyWriteoffAmount: Math.round((x.AllWriteoffAmount + Number(x.ActualFreight || 0)) * 10000) / 10000,
          WriteoffAmount: x.WriteoffAmount,
          Remark: x.Remark,
          AllowanceAmount: x.DiscountAmount,
          T: null
        })
      })
      this.data.WoDocs = []
      this.data.WoDts = null
    },
    openCustomer() {
      this.$refs.customerDialog.open()
    },
    setSupplier(data) {
      this.data.TradeUnitId = data.TradeUnitId
      this.data.TradeUnitName = data.TradeUnitName
      this.data.TradeUnitType = data.TradeUnitType
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData({ Status: 1 })
      })
    },
    setEmp(data) {
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    addDts() {
      var item = {
        DtsId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: '',
        AccountId: null,
        AccountName: '',
        ReceiptAmount: null,
        Remark: '',
        T: 0
      }
      this.data.Dts.push(item)
    },
    setSettle(row) {
      var settle = this.Settles.find(x => x.SettleId == row.SettleId)
      // row.AccountId = settle.AccountId;
      // row.AccountName = settle.AccountName;

      // this.DAccount = this.DAccount.filter(item => {
      //   console.log('item', item,  row.AccountName)
      //   return item.AccountName === row.AccountName;
      // })
      // this.listTotal=this.DAccount.length;
    },
    onSelect(e, row) {
      row.T = row.T == 0 ? 0 : 1
      row.AccountId = e.AccountId
      row.AccountName = e.AccountName
    },

    onInput1(row, type) {
      row.T = row.T == 0 ? 0 : 1
      if (type) {
        // row[type] = this.$commonJs.obj.toNumber(row[type]);
        var items2 = this.data.Dts.filter(x => !!x.ReceiptAmount).map(x => parseFloat(x.ReceiptAmount))
        if (items2.length > 0) {
          this.DtsTotal = items2.reduce((a, b) => {
            return Number(a) + Number(b)
          })
        } else this.DtsTotal = 0
      }
    },
    onInput4(row) {
      if (row) {
        row.T = row.T === 0 ? 0 : 1
      }
      var items2 = this.data.Dts.filter(x => !!x.ReceiptAmount).map(x => parseFloat(x.ReceiptAmount))
      if (items2.length > 0) {
        this.DtsTotal = items2.reduce((a, b) => {
          return Number(a) + Number(b)
        })
      } else this.DtsTotal = 0

      var amount = Number(this.DtsTotal)
      if (amount >= 0) {
        this.data.WoDocs.map(x => {
          if (this.curRows.includes(x.SourceId)) {
            x.T = x.T === 0 ? 0 : 1
            if (x.ReceiptAmount >= amount) {
              x.WriteoffAmount = amount
              this.Detail.ThisAmount += amount
            } else if (x.ReceiptAmount < amount) {
              x.WriteoffAmount = x.ReceiptAmount
              this.Detail.ThisAmount += x.ReceiptAmount
            } else {
              x.WriteoffAmount = 0
            }
            amount = Number(Number(Number(amount) - Number(x.WriteoffAmount)).toFixed(2))
          }
        })
      } else {
        this.data.WoDocs.map(x => {
          if (this.curRows.includes(x.SourceId)) {
            x.T = x.T === 0 ? 0 : 1
            this.data.TotalAllowanceAmount = 0
            x.AllowanceAmount = 0
            if (x.ReceiptAmount <= amount) {
              x.WriteoffAmount = amount
              this.Detail.ThisAmount += amount
            } else if (x.ReceiptAmount > amount) {
              x.WriteoffAmount = x.ReceiptAmount < 0 ? x.ReceiptAmount : 0
              this.Detail.ThisAmount += x.ReceiptAmount < 0 ? x.ReceiptAmount : 0
            } else {
              x.WriteoffAmount = 0
            }
            amount = Number(Number(Number(amount) - Number(x.WriteoffAmount)).toFixed(2))
          }
        })
      }
      this.onInputAmount()
    },
    setWriteoffAmount() {
      this.Detail.ThisAmount = 0
      this.Detail.ToAmount = 0
      this.data.WoDocs.map(x => {
        if (this.curRows.includes(x.SourceId)) {
          var result = Number(x.WriteoffAmount) + Number(x.AllowanceAmount)
          if (x.ReceiptAmount >= 0) {
            x.WriteoffAmount = result > x.ReceiptAmount ? x.ReceiptAmount : result
          }
          this.Detail.ThisAmount += Number(x.WriteoffAmount)
          this.Detail.ToAmount += Number(x.ReceiptAmount)
        }
      })
    },
    delDts(row, index) {
      if (row.T != 0) this.DelDts.push({ ...row, T: 2 })
      this.data.Dts.splice(index, 1)
      this.onInput4(row)
    },
    search() {
      if (!this.data.TradeUnitId) {
        this.$message.warning('请先选择往来单位')
        return
      }
      var parmas = {
        TradeUnitId: this.data.TradeUnitId,
        BusinessType: this.data.BusinessType,
        DocDateStart: this.SearchData.DocDateStart,
        DocDateEnd: this.SearchData.DocDateEnd
      }
      // console.log("查询");
      this.wodoc_api.needRcvList(parmas).then(res => {
        // console.log(res);
        if (res.Code == 0) {
          this.WoDocs = []
          this.Detail.ToCount = res.Count
          if (res.Data.length == 0) {
            this.$message.warning('暂无核销单据明细')
            return
          }

          let minusData = res.Data.filter(x => x.Amount < 0)
          let plusData = res.Data.filter(x => x.Amount > 0)
          let woDocData = minusData.concat(plusData)
          woDocData.forEach(x => {
            this.WoDocs.push({
              WoDocId: 0,
              DocId: this.data.DocId,
              DocDate: x.DocDate,
              SourceId: x.SourceId,
              SourceNo: x.DocNo,
              SourceType: x.SrcVouType,
              SrcVouTypeName: x.SrcVouTypeName,
              Amount: Math.round((x.Amount + Number(x.ActualFreight || 0)) * 10000) / 10000,
              ReceiptAmount: Math.round((x.Amount + Number(x.ActualFreight || 0) - Number(x.WriteoffAmount || 0)) * 10000) / 10000,
              AlreadyWriteoffAmount: x.AlreadyWriteoffAmount,
              WriteoffAmount: null,
              AllowanceAmount: null,
              Remark: '',
              T: 0
            })
          })
        }
      })
    },
    clear() {
      console.log('清空')
      var config = {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      this.$confirm('确认清空已核销明细吗？', '提示', config)
        .then(() => {
          // if (this.isEdit) {
          //   var rows = this.WoDocs.filter((x) => x.T != 0);
          //   this.DelWoDocs = rows.map((x) => {
          //     return { ...x, T: 2 };
          //   });
          // }
          // this.data.WoDocs = [];
          // this.WoDocs = [];
          this.api.clear(this.data.DocId).then(res => {
            if (res.Code == 0) {
              this.$message.success('清空明细成功')
              // this.search();
              this.WoDocs = []
              this.curRows = []
            } else this.$message.error(res.Msg)
          })
        })
        .catch(() => {})
    },
    onTbSelect(rows) {
      // this.data.WoDocs = rows;
      this.Detail.IsCount = this.data.WoDocs.length
      // var items1 = this.data.WoDocs.map((x) => parseFloat(x.ReceiptAmount));
      // if (items1.length > 0) {
      //   this.Detail.ToAmount = items1.reduce((a, b) => {
      //     return a + b;
      //   });
      // } else this.Detail.ToAmount = 0;
      // if(this.Detail.ToAmount%1 !=0){
      //   this.Detail.ToAmount=this.Detail.ToAmount.toFixed(2)
      // }
      var thisAmount = this.DtsTotal
      var ids = rows.map(x => x.SourceId)
      this.curRows = ids
      // var allAmount = this.data.TotalAllowanceAmount
      // this.WoDocs.forEach((i,index) => {
      //   if (!ids.includes(i.SourceId)) {
      //     i.WriteoffAmount = null;
      //     this.$set(i,'AllowanceAmount',null)
      //     this.$set(i,'Adisable',true)
      //     // i.AllowanceAmount = null;
      //   }else{
      //     var num = (allAmount?allAmount/ids.length:0).toFixed(2)
      //     this.$set(i,'AllowanceAmount',num)
      //     this.$set(i,'Adisable',false)
      //   }
      //   if(this.isEdit == true){
      //     this.$set(i,'T',1)
      //   }
      // });
      this.data.WoDocs = this.WoDocs // 过滤选中数组
      // this.WoDocs.forEach((x) => (x.WriteoffAmount = null));
      var amount = thisAmount
      this.data.WoDocs.forEach(x => {
        if (thisAmount >= 0) {
          if (ids.includes(x.SourceId)) {
            if (x.ReceiptAmount >= amount) {
              x.WriteoffAmount = amount
            } else if (x.ReceiptAmount < amount) {
              x.WriteoffAmount = x.ReceiptAmount
            } else {
              x.WriteoffAmount = 0
            }
            amount = Number(Number(Number(amount) - Number(x.WriteoffAmount)).toFixed(2))
          }
        } else {
          if (ids.includes(x.SourceId)) {
            if (x.ReceiptAmount <= 0) {
              if (x.ReceiptAmount <= amount) {
                x.WriteoffAmount = amount
              } else if (x.ReceiptAmount > amount) {
                x.WriteoffAmount = x.ReceiptAmount
              } else {
                x.WriteoffAmount = 0
              }
              amount = Number(Number(Number(amount) - Number(x.WriteoffAmount)).toFixed(2))
            } else {
              x.WriteoffAmount = 0
            }
          }
        }
      })
      this.onInputAmount()
      // var items2 = this.data.WoDocs.filter((x) => !!x.WriteoffAmount).map((x) =>
      //   parseFloat(x.WriteoffAmount)
      // );
      // if (items2.length > 0) {
      //   this.Detail.ThisAmount = items2.reduce((a, b) => {
      //     return a + b;
      //   });
      // } else {
      //   this.Detail.ThisAmount = 0;
      // }
      var total = 0
      this.data.WoDocs.map(item => {
        if (this.curRows.includes(item.SourceId)) {
          total += Number(item.WriteoffAmount)
        }
      })
      this.Detail.ThisAmount = total
    },
    onInput2(row, type) {
      row.T = row.T == 0 ? 0 : 1
      if (type) {
        if (row[type] > 0) {
          if (row.ReceiptAmount < 0) {
            row[type] = 0
          } else {
            row[type] = Number(row[type]) > Number(row.ReceiptAmount) ? row.ReceiptAmount : row[type]
          }
        } else if (row[type] < 0) {
          if (row.ReceiptAmount > 0) {
            row[type] = 0
          } else {
            row[type] = Number(row[type]) < Number(row.ReceiptAmount) ? row.ReceiptAmount : row[type]
          }
        } else {
          row[type] = 0
        }
      }

      // var items2 = this.data.WoDocs.filter((x) => !!x.WriteoffAmount).map((x) =>
      //   parseFloat(x.WriteoffAmount)
      // );
      // if (items2.length > 0) {
      //   this.Detail.ThisAmount = items2.reduce((a, b) => {
      //     return Number(a) + Number(b);
      //   });
      // } else {
      //   this.Detail.ThisAmount = 0;
      // }
      var total = 0
      this.data.WoDocs.map(item => {
        if (this.curRows.includes(item.SourceId)) {
          total += Number(item.WriteoffAmount)
        }
      })
      this.Detail.ThisAmount = total
    },
    onBeforeSave() {
      if (this.data.Dts.length == 0) {
        this.$message.warning('收款信息不能为空')
        return false
      }

      var account = this.data.Dts.every(x => !!x.AccountId)
      if (!account) {
        this.$message.warning('收款信息 - 收款账号不能为空')
        return false
      }
      var settle = this.data.Dts.every(x => !!x.SettleId)
      if (!settle) {
        this.$message.warning('收款信息 - 结算方式不能为空')
        return false
      }

      // var amount1 = this.data.Dts.every((x) => !!x.ReceiptAmount);
      // if (!amount1) {
      //   this.$message.warning("收款信息 - 收款金额不能为空");
      //   return false;
      // }

      // var amount2 = this.data.WoDocs.every((x) => !!x.WriteoffAmount);
      // if (!amount2) {
      //   this.$message.warning("核销单据明细 - 所选明细的本次核销金额不能为空");
      //   return false;
      // }
      if (this.data.WoDocs.length == 0 && this.data.BusinessType == 0) {
        this.$message.warning('请选择已核销明细')
        return false
      }

      for (let i = 0; i < this.data.Dts.length; i++) {
        var e = this.data.Dts[i]
        if (!(e.ReceiptAmount > 0 || e.ReceiptAmount < 0)) {
          e.ReceiptAmount = 0
        }
      }

      for (let i = 0; i < this.data.WoDocs.length; i++) {
        var e = this.data.WoDocs[i]
        if (!(e.WriteoffAmount > 0 || e.WriteoffAmount < 0)) {
          e.WriteoffAmount = 0
        }
      }
      var TotalAllowanceAmount = this.data.TotalAllowanceAmount ? this.data.TotalAllowanceAmount : 0
      var countNum = parseFloat(this.DtsTotal) + parseFloat(TotalAllowanceAmount)
      if (this.data.BusinessType == 0 && this.data.WoDocs.length > 0) {
        if (parseFloat(this.Detail.ThisAmount).toFixed(2) != countNum.toFixed(2)) {
          console.log(parseFloat(this.Detail.ThisAmount).toFixed(2), countNum.toFixed(2))
          this.$message.warning('本次核销金额总和需等于收款金额总和与折让金额总和')
          return false
        }
      }

      var data = this.$commonJs.obj.removeNullKey(this.data)
      data.DiscountAmount = TotalAllowanceAmount
      data.Dts = this.data.Dts.filter(x => x.T != null)
      data.WoDocs = this.data.WoDocs.filter(x => x.T != null)

      data.WoDocs = []
      this.data.WoDocs.forEach(e => {
        if (e.WriteoffAmount != 0) {
          if (this.curRows.includes(e.SourceId)) {
            e.DiscountAmount = e.AllowanceAmount
            data.WoDocs.push(e)
          } else if (!(e.T === 0)) {
            e.T = 2
            data.WoDocs.push(e)
          }
        }
      })

      this.DelDts.forEach(x => data.Dts.push(x))
      if (data.BusinessType == 1) data.WoDocs = []

      console.log('api.save', data)

      this.$refs.dialog.isLoading = true
      this.api.save(data).then(res => {
        this.$refs.dialog.isLoading = false
        if (res.Code == 0) {
          this.$nextTick(function () {
            this.api
              .updateSaDoc(res.Data)
              .then(() => {})
              .catch()
          })
          this.$message.success(res.Msg)

          this.$emit('close-saved')
          this.close(true)
        } else {
          this.$message.error(res.Msg)
        }
      })
      return false
    },

    onClosed() {
      this.isEdit = false
      this.DelDts = []
      this.data.Dts = []
      this.data.WoDocs = []
      this.WoDocs = []
      this.Rows = []
      this.DtsTotal = 0

      this.Detail.ToCount = 0 //待核销单据
      this.Detail.IsCount = 0 //已核销单据
      this.Detail.ToAmount = 0 //未核销金额
      this.Detail.ThisAmount = 0 //本次核销金额
      this.Detail.DiffAmount = 0 //核销差额
    }
  }
}
</script>
<style lang="scss" scoped>
.head-item {
  width: 125px;
  display: inline-block;
}
</style>
